import {
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Upload,
  Button,
} from "antd";
import React from "react";
import "./style.css";
import {
  disabledDate,
  openNotificationWithIcon,
  validateMessages,
} from "../../../Function";
import { UploadOutlined } from "@ant-design/icons";

const dateFormat = "DD/MM/YYYY";

const ModalAddCandidate = ({
  form,
  isModalOpenAddCandidate,
  onCancelAddCandidate,
  onChangeCheckBoxGender,
  onFinishAddCV,
  dataDetail,
  listCandidateSource,
  listEducationLevel,
  // listLanguageSkill,
  handleChangeUploadCV,
  uploadFileCV,
  ls_city,
  handleCityChange,
  listDistrict,
}) => {
  const ComponentUploadFile = ({}) => {
    return (
      <Upload
        accept=".doc, .docx, .pdf"
        onChange={handleChangeUploadCV}
        fileList={uploadFileCV}
        className=""
        maxCount={1}
        beforeUpload={(file) => {
          const checkSize = file.size / 1024 / 1024 > 10;
          if (checkSize) {
            openNotificationWithIcon("error", "Lỗi", `File CV đã quá 10MB !`);
            return Upload.LIST_IGNORE;
          }

          form.setFieldsValue({
            file_upload: file.name,
          });
          return false;
        }}
        showUploadList={false}
      >
        <span style={{ cursor: "pointer" }}>
          <UploadOutlined /> Tải lên
        </span>
      </Upload>
    );
  };

  return (
    <Modal
      title={`Thêm mới hồ sơ ứng viên ${
        dataDetail != [] && dataDetail.results != undefined
          ? `(Mã: ${dataDetail.results.ticket_code})`
          : ""
      }`}
      open={isModalOpenAddCandidate}
      onCancel={() => {
        onCancelAddCandidate();
        form.resetFields();
      }}
      width={800}
      footer={false}
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={(values) => {
          onFinishAddCV(values);
        }}
        // onFinishFailed={onFinishFailed}
        validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
      >
        <Row className="modal-add-candidate-row">
          <Col span={11}>
            <Form.Item
              label="Họ và tên"
              name="first_name"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  required: true,
                },
                {
                  pattern: /^[a-zA-ZÀ-ỹ0-9]+(?:\s[a-zA-ZÀ-ỹ0-9]+)*$/,
                  message: "Họ và Tên có khoảng trắng bị thừa / sai định dạng!",
                },
                {
                  min: 3,
                  message: "Họ và Tên phải có ít nhất 3 ký tự!",
                },
              ]}
            >
              <Input placeholder="Họ và tên"></Input>
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item
              label="Ngày sinh"
              name="birthday"
              className="modal-add-cadidate-form-item"
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <DatePicker
                suffixIcon={null}
                placeholder="DD/MM/YYYY"
                // onChange={handleStartDate}
                format={dateFormat}
                disabledDate={disabledDate}
                // value={startDate}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Giới tính"
              name="gender"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Radio.Group onChange={onChangeCheckBoxGender}>
                <Radio value={"Nam"}>Nam</Radio>
                <Radio value={"Nữ"}>Nữ</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={5} offset={1}>
            <Form.Item
              label="Số điện thoại"
              name="numberphone"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  required: true,
                },
                {
                  pattern: /^\d+$/,
                  message: "Số điện thoại chỉ được nhập bằng số",
                },
                {
                  min: 10,
                  message: "Số điện thoại có ít nhất 10 ký tự",
                },
                {
                  max: 12,
                  message: "Số điện thoại có tối đa 12 ký tự",
                },
              ]}
            >
              <Input placeholder="Số điện thoại"></Input>
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item
              label="Tỉnh/Thành phố"
              name="city_code"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                allowClear={true}
                placeholder="Chọn Tỉnh/Thành phố"
                onChange={handleCityChange}
                showSearch={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {ls_city != undefined &&
                  ls_city.map((item) => (
                    <Select.Option key={item.code} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              label="Địa chỉ"
              name="address"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  required: true,
                },
                {
                  pattern: /^[a-zA-ZÀ-ỹ0-9,.\-/]+(?:\s[a-zA-ZÀ-ỹ0-9,.\-/]+)*$/,
                  message: "Địa chỉ không hợp lệ! Hãy kiểm tra lại.",
                },
                {
                  min: 5,
                  message: "Địa chỉ phải có ít nhất 5 ký tự!",
                },
              ]}
            >
              <Input placeholder="Địa chỉ"></Input>
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item
              label="Quận/Huyện"
              name="district_code"
              className="modal-add-cadidate-form-item"
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <Select placeholder="Chọn Quận/Huyện">
                {listDistrict.length > 0
                  ? listDistrict.map((district) => (
                      <Select.Option key={district.code} value={district.code}>
                        {district.name}
                      </Select.Option>
                    ))
                  : null}
              </Select>
            </Form.Item>
          </Col>

          <Col span={11}>
            <Form.Item
              label="Email"
              name="email"
              className="modal-add-cadidate-form-item"
              rules={[{ type: "email" }]}
            >
              <Input placeholder="Email"></Input>
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item
              label="Trình độ học vấn"
              name="education_level"
              className="modal-add-cadidate-form-item"
            >
              <Select
              // onChange={handleChangeProfileStatus}
              >
                {listEducationLevel.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              label="Chuyên ngành"
              name="education_major"
              className="modal-add-cadidate-form-item"
              rules={[
                {
                  pattern: /^[a-zA-ZÀ-ỹ0-9]+(?:\s[a-zA-ZÀ-ỹ0-9]+)*$/,
                  message: "Ký tự không hợp lệ.",
                },
                {
                  min: 2,
                  message: "Chuyên ngành phải có ít nhất 2 ký tự!",
                },
              ]}
            >
              <Input placeholder="Tiếng Nhật, Công nghệ thông tin, ...."></Input>
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item
              label="Trình độ ngoại ngữ"
              name="language_skill"
              className="modal-add-cadidate-form-item"
            >
              <Input
                placeholder="Tiếng Anh, Tiếng Nhật N1,..."
                // className="input-right-create-cv"
              />
              {/* <Select>
                {listLanguageSkill.map((item) => (
                  <Select.Option key={item.id} value={item.name}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              label="Ngày ứng tuyển"
              name="application_date"
              className="modal-add-cadidate-form-item"
            >
              <DatePicker
                suffixIcon={null}
                placeholder="DD/MM/YYYY"
                // onChange={handleStartDate}
                format={dateFormat}
                // value={startDate}
              />
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item
              label="Nguồn ứng viên"
              name="candidate_source"
              className="modal-add-cadidate-form-item"
            >
              <Select
                placeholder="Nguồn ứng viên"
                allowClear
                // onChange={handleChangeProfileStatus}
              >
                {listCandidateSource != undefined &&
                  listCandidateSource.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="File CV" name="file_upload">
              <Input addonAfter={<ComponentUploadFile />}></Input>
            </Form.Item>
          </Col>
          {/* <Col span={11} offset={2}>
            <Form.Item label="Ghi chú" name="note">
              <Input.TextArea
                autoSize={{
                  minRows: 2,
                }}
              />
            </Form.Item>
          </Col> */}
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginRight: 32 }}
            >
              Lưu
            </Button>

            <Button onClick={onCancelAddCandidate}>Thoát</Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalAddCandidate;
